'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GlobalHeader = require('./v1/GlobalHeader');

var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);

var _GlobalHeader3 = require('./v2/GlobalHeader');

var _GlobalHeader4 = _interopRequireDefault(_GlobalHeader3);

var _GlobalHeader5 = require('./v3/GlobalHeader');

var _GlobalHeader6 = _interopRequireDefault(_GlobalHeader5);

var _GlobalHeader7 = require('./v4/GlobalHeader');

var _GlobalHeader8 = _interopRequireDefault(_GlobalHeader7);

var _MPPHeaderDefaultProps = require('./components/MPPHeaderDefaultProps');

var _MPPHeaderDefaultProps2 = _interopRequireDefault(_MPPHeaderDefaultProps);

var _MPPHeaderPropTypes = require('./components/MPPHeaderPropTypes');

var _MPPHeaderPropTypes2 = _interopRequireDefault(_MPPHeaderPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPHeader = function (_React$Component) {
  _inherits(MPPHeader, _React$Component);

  function MPPHeader() {
    _classCallCheck(this, MPPHeader);

    return _possibleConstructorReturn(this, (MPPHeader.__proto__ || Object.getPrototypeOf(MPPHeader)).apply(this, arguments));
  }

  _createClass(MPPHeader, [{
    key: 'render',
    value: function render() {
      var headerVersion = this.props.config && this.props.config.version || 'v1';
      // Header versions: V1, V2
      switch (headerVersion) {
        case 'v2':
          return _react2.default.createElement(_GlobalHeader4.default, this.props);
        case 'v3':
          return _react2.default.createElement(_GlobalHeader6.default, this.props);
        case 'v4':
          return _react2.default.createElement(_GlobalHeader8.default, this.props);
        default:
          return _react2.default.createElement(_GlobalHeader2.default, this.props);
      }
    }
  }]);

  return MPPHeader;
}(_react2.default.Component);

exports.default = MPPHeader;


MPPHeader.propTypes = _MPPHeaderPropTypes2.default;
MPPHeader.defaultProps = _MPPHeaderDefaultProps2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/MPPHeader.js
// module id = 573
// module chunks = 4